import { IResponseActivity, IResponseSendAsset, IResponseVerifyAddress } from '@/core/domain/entities/activities';
import {
  IRequestFee,
  IRequestSendAsset,
  IRequestTokenTransactions,
  IRequestTransactions,
} from '@/core/domain/entities/request';
import { IResponseBalance } from '@/core/domain/entities/user';
import { mapSendAsset, mapTransactions, mapVerifyAddress } from '@/core/domain/mapper/mapActivities';
import { checklocal } from '@/utils';
import axios from 'axios';

/**
 * 트론 거래내역 조회
 * @param {IRequestTransactions} reqData
 * @returns {Promise<string | IResponseActivity[]>}
 */
export async function fetchTransactions(reqData: IRequestTransactions): Promise<string | IResponseActivity[]> {
  try {
    const response = await axios.post(`${checklocal()}/wallet/trx/transactions`, reqData);

    return mapTransactions(response.data);
  } catch (err) {
    console.error('Transaction error:', err);
    if (axios.isAxiosError(err)) {
      return err.response?.data.errorCode.code;
    }
    return '0000';
  }
}

/**
 * 토큰 거래내역 조회
 * @param {IRequestTokenTransactions} reqData
 * @returns {Promise<string | IResponseActivity[]>}
 */
export async function fetchTokenTransactions(
  reqData: IRequestTokenTransactions,
): Promise<string | IResponseActivity[]> {
  try {
    const response = await axios.post(`${checklocal()}/wallet/token/transactions`, reqData);
    // mock data
    // const response = MOCK_TOKEN_TRANSACTIONS;

    return mapTransactions(response.data.result);
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      return err.response?.data.errorCode.code;
    }

    return '0000';
  }
}

export async function checkTokenPrice(): Promise<string | number> {
  try {
    const response = await axios.get(`${checklocal()}/wallet/token/price`);

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      return err.response?.data.errorCode.code;
    }

    return '0000';
  }
}

export async function checkTrxPrice(): Promise<string | number> {
  try {
    const response = await axios.get(`${checklocal()}/wallet/trx/price`);

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      return err.response?.data.errorCode.code;
    }

    return '0000';
  }
}

export async function sendAsset(reqData: IRequestSendAsset): Promise<string | IResponseSendAsset> {
  try {
    const response = await axios.post(`${checklocal()}/wallet/token/transfer`, reqData);

    return mapSendAsset(response.data.result);
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      return err.response?.data.errorCode.code;
    }

    return '0000';
  }
}

export async function sendTrx(reqData: IRequestSendAsset): Promise<string | IResponseSendAsset> {
  try {
    const response = await axios.post(`${checklocal()}/wallet/trx/transfer`, reqData);

    return mapSendAsset(response.data.result);
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      return err.response?.data.errorCode.code;
    }

    return '0000';
  }
}

export async function verifyAddress(address: string): Promise<string | IResponseVerifyAddress> {
  try {
    const response = await axios.post(`${checklocal()}/wallet/trx/verifyaddress`, { address });

    return mapVerifyAddress(response.data.result);
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      return err.response?.data.errorCode.code;
    }

    return '0000';
  }
}

export async function fetchBalance(address: string): Promise<string | IResponseBalance> {
  try {
    const response = await axios.post(`${checklocal()}/wallet/balance`, { address });

    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      return err.response?.data.errorCode.code;
    }

    return '0000';
  }
}

export async function fetchFee(reqData: IRequestFee): Promise<string | number> {
  try {
    const response = await axios.post(`${checklocal()}/wallet/trx/networkfee`, reqData);
    return response.data.result;
  } catch (err) {
    console.error(err);
    if (axios.isAxiosError(err)) {
      return err.response?.data?.errorCode?.code || '0000';
    }
    return '0000';
  }
}
